import React, { useRef, useContext, useEffect } from "react"
import styled from "styled-components"
import ContentWrapper from "styles/contentWrapper"
import { MDXRenderer } from "gatsby-plugin-mdx"
const checkIcon = "https://hrflow-ai.imgix.net/check.svg"
const cancelIcon = "https://hrflow-ai.imgix.net/cancel.svg"
const featuresLogo = "https://hrflow-ai.imgix.net/features.svg"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
  .section-title {
    margin-bottom: 3rem;
    padding: 0 1rem;
    span {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
  .section-subtitle {
    margin-bottom: 4rem;
    font-weight: 400;
    text-align: center;
    font-size: 1.2rem;
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
  }

  .table {
    width: 100%;
    border: 1px solid #bddae3;
    box-sizing: border-box;
    border-top-right-radius: 1rem;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    border-top: none;
    .table__header {
      display: flex;
      justify-content: space-between;
      @media (max-width: 600px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .features {
          margin-bottom: 1rem;
        }
      }
      padding: 2rem;
      .features {
        display: flex;
        align-items: center;
        .logo {
          background-image: url(${featuresLogo});
          background-size: 3.3rem 3.74rem;
          background-repeat: no-repeat;
          height: 3.74rem;
          width: 3.3rem;
          margin-right: .85rem;
        }
        .text {
          line-height: 1.75rem;
          font-size: 1.5rem;
          font-weight: 600;
          letter-spacing: -.05rem;
          color: #00495d;
        }
      }
      .enterprise {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .button-plan {
          background: #00cee0;
          border-radius: .25rem;
          line-height: normal;
          font-size: .7rem;
          text-align: center;
          letter-spacing: .065rem;
          text-transform: uppercase;
          color: #fff;
          border-style: none;
          padding: .7rem 2.8rem .85rem 2.8rem;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
    .table__body {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      max-width: 100%;
      border-top-right-radius: 1rem;
      border-top-left-radius: 1rem;
      .table__row {
        border-top: 1px solid #bddae3;
        text-align: center;
        border-top-right-radius: 1rem;
        border-top-left-radius: 1rem;
        .item {
          background-color: #f8feff;
          border-top-right-radius: 1rem;
          border-top-left-radius: 1rem;
          @media (max-width: 800px) {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
          .text {
            line-height: 1.85rem;
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: -.05rem;
            color: #00495d;
          }
          .hrflow {
            opacity: 1;
          }
          .cel {
            width: 25.16%;
            line-height: 1.85rem;
            font-size: 1.2rem;
            letter-spacing: -.05rem;
            color: #00495d;
            word-break: break-all;
            font-weight: 700;
            padding: 1.5rem 0;
            &.hrflow {
              opacity: 1;
            }
            @media (max-width: 500px) {
              font-size: 0.5rem;
            }
            &.imp {
              border-right: 1px solid #bddae3;
              opacity: 1;
              border-top: none;
            }
            &:nth-of-type(1) {
              justify-content: flex-start;
              margin-left: 1rem;
              text-align: left;
              font-weight: 700;
              font-family: 'plain-regular';
            }
            &:nth-of-type(2) {
              color: #EF884A;
              background-color: rgba(255, 226, 209, 0.5);
            }
            &:nth-of-type(3) {
              color: #30BFD9;
              background-color: rgba(202, 228, 232, 0.5);
            }
            &:nth-of-type(4) {
              color: #80D930;
              background-color: rgba(222, 246, 215, 0.5);
            }
            &:nth-of-type(5) {
              color: #7775F5;
              background-color: rgba(243, 243, 255, 0.5);
              border-top-right-radius: 1rem;
            }
          }
        }
        .content {
          .content__row {
            border-top: 1px solid #bddae3;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            @media (max-width: 800px) {
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            }
            .cel {
              width: 25.16%;
              line-height: 1.85rem;
              font-size: 1rem;
              letter-spacing: -.05rem;
              color: #00495d;
              padding-top: .95rem;
              padding-bottom: .9rem;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-wrap: wrap;
              word-break: break-all;
              &.hrflow {
                opacity: 1;
              }
              @media (max-width: 500px) {
                font-size: 0.5rem;
              }
              .tag {
                border-radius: 0.25rem;
                background-color: #f0f4f8;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
                margin: 0.2rem;
                max-height: 2.5rem;
              }
              &.imp {
                background-color: #f8feff;
                border-right: 1px solid #bddae3;
                opacity: 1;
              }
              .times {
                background-image: url(${cancelIcon});
                background-position: center;
                background-size: 1.45rem 1.45rem;
                height: 1.45rem;
                width: 1.45rem;
                background-repeat: no-repeat;
              }
              .check {
                background-image: url(${checkIcon});
                background-position: center;
                background-size: 1.45rem 1.45rem;
                height: 1.45rem;
                width: 1.45rem;
                background-repeat: no-repeat;
              }
              &:nth-of-type(1) {
                justify-content: flex-start;
                margin-left: 1rem;
              }
              &:nth-of-type(2) {
                background-color: rgba(255, 226, 209, 0.5);
              }
              &:nth-of-type(3) {
                background-color: rgba(202, 228, 232, 0.5);
              }
              &:nth-of-type(4) {
                background-color: rgba(222, 246, 215, 0.5);
              }
              &:nth-of-type(5) {
                background-color: rgba(243, 243, 255, 0.5);
              }
            }
            &:last-of-type {
              .cel:first-of-type {
                border-bottom-left-radius: 1rem;
              }
              .cel:last-of-type {
                border-bottom-right-radius: 1rem;
              }
            }
            &.empty {
              .cel.imp {
                border-right: none;
              }
              .cel {
                background: #f8feff;
              }
            }
            &.separator {
              .cel.imp {
                font-size: 1.2rem;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }
`


const AllFeatures = ({ content }) => {
  const { frontmatter, body } = content[0].node
  return (
    <StyledSection id="Compare">
      <StyledContentWrapper>
        <h2 className="section-title">
          {frontmatter.title}
        </h2>
        <div className="table benchmark parsing">
          <MDXRenderer>{body}</MDXRenderer>
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default AllFeatures